import type { ISupplierNote } from './../types/note/models'
import { makeNoteService } from '~/cynqueModules/factoriesForServices/notes'

export const {
  createNote: createSupplierNote,
  updateNote: updateSupplierNote,
  deleteNote: deleteSupplierNote,
} = makeNoteService<ISupplierNote>('/api/suppliernotes', 'supplierNote')
